import http from './http';
import {ENUMS} from "../services/enums";

export default {
  all() {
    return http().get(`/v1/call_script_steps`);
  },
  get(id) {
    return http().get(`/v1/call_script_steps/${id}`);
  },
  getFields(type = null) {
    type = type || ENUMS.CallScriptTypeEnum.Lead.value;
    return http().get(`/v1/call_script_steps/fields/` + type);
  },
  create(data) {
    return http().post(`/v1/call_script_steps`, data);
  },
  updateSequence(data) {
    return http().post(`v1/call_script_steps/sort`, data);
  },
  update(data) {
    return http().put(`/v1/call_script_steps/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/call_script_steps/${id}`);
  },
}
